import './public-path';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'antd/dist/reset.css';
import '../styles.css';
import './styles/app.css';
import App from './App';

// React 18 的 root 实例需要在 qiankun unmount 时保存下来，
// 这样子应用卸载时才能释放事件监听、组件状态和 DOM 引用。
let root;

/**
 * 渲染入口。
 *
 * 这个函数同时服务两种运行模式：
 * 1. 独立运行：本地开发或普通静态部署时，直接挂载到页面的 #root。
 * 2. qiankun 子应用：主应用会把 container 传进来，子应用必须挂载到主应用分配的容器中。
 */
function render(props = {}) {
  const container = props.container
    ? props.container.querySelector('#root')
    : document.getElementById('root');

  root = createRoot(container);

  // basename 允许同一套 React Router 在不同部署基座下工作。
  // 独立运行默认是 /，被 qiankun 挂载时可由主应用传入 baseName。
  root.render(<App basename={props.baseName || process.env.REACT_APP_ROUTER_BASE || '/'} />);
}

// 非 qiankun 环境下自动渲染，保证 npm run start / 普通部署可以直接访问。
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

// qiankun 生命周期：bootstrap 只做一次初始化准备。
export async function bootstrap() {
  return Promise.resolve();
}

// qiankun 生命周期：每次子应用进入时由主应用调用 mount。
export async function mount(props) {
  render(props);
}

// qiankun 生命周期：离开子应用时清理 React root。
export async function unmount() {
  if (root) {
    root.unmount();
    root = null;
  }
}
